<template>
<div>
  <v-card
    color="cloud"
    tile
    class="d-flex align-center pa-2"
  >
    <v-badge
      :content="notify_nums"
      :value="notify_nums>0"
      color="deepLava"
      overlap
    >
      <v-icon color="white">mdi-bell</v-icon>
    </v-badge>
    <p style="color:white" class="my-0">全体通知</p>
    <v-btn class="ml-auto" rounded color="#008CFF" dark @click="$emit('openModal', null)">表示</v-btn>
  </v-card>
  <v-list class="py-0 mt-0" style="width:300px; max-height:400px; z-index:5000; background-color:white; overflow: hidden scroll;" v-if="notify.length>0">
    <v-list-item three-line v-for="(item, index) in notify" :key="item.sort">
      <v-list-item-content>
        <v-list-item-title class="d-flex" style="color:#2B2B2B">
          <v-icon color="deepLava" size="small" v-if="item.isNew">mdi-circle</v-icon>
          <span class="my-auto" style="white-space: pre-wrap; max-width: 250px;">{{ item.title }}</span>
          <!-- もしitem.isImportantなら赤にしたい -->
          <v-chip :color="item.isImportant?'#BA0009':'#399942'" dark class="ml-auto"><span v-text="item.tag"></span></v-chip>
        </v-list-item-title>
        <!-- <div style="color:#2B2B2B" class="my-2" v-html="item.content"></div> -->
        <v-list-item-subtitle class="d-flex align-center">
          <v-btn v-if="enabledCheckNotify(item.type)" @click="checkNotify(item,index)" text style="background-color:#dcdcdc; font-size:10px;">確認する</v-btn>
          <span class="ml-auto"></span><span v-if="item.createdAt" v-text="item.createdAt.toDate().toLocaleString()"></span><span v-if="item.created" v-text="item.created.toDate().toLocaleString()"></span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <div v-else style="background-color:white">
    <p class="text-center py-4 mb-0">通知はありません。</p>
  </div>
</div>
</template>

<script>
//import notifyDetail from './notifyDetail.vue'
  import firebase from 'firebase'
  export default ({
    props: {
      isSp: Boolean,
    },
    components:{
      //notifyDetail
    },
    data () {
      return {
      db:null,
      notiDesk: false,
      notiMob: false,
      notiLine: false,
      toUser: "all",
      content:"",
      toTheUser: "",
      detailNotification: false
    }},
    computed:{
      admins(){
        return this.$store.state.admins
      },
      liqAdmins(){
        return this.$store.state.liqAdmins
      },
      namelist(){
        return this.$store.state.namelist
      },
      isAdmin(){
        return this.$store.state.isAdmin
      },
      basetitle(){
        return this.$store.state.basetitle
      },
      lid(){
        return this.$store.state.lid
      },
      alid(){
        return this.$store.state.alid
      },
      config(){
        if(this.$store.state.config.logoSrc) console.log(this.$store.state.config.logoSrc)
        else console.log("img")
        return this.$store.state.config
      },
      members(){
        return this.$store.state.members
      },
      uid() {
        return this.$store.state.auth?.user?.uid || '';
      },
      currentName() {
        return this.$store.state.auth.user.displayName;
      },
      isAuthed() {
        return !this.$store.state.auth.user.isAnonymous || false;
      },
      notify(){
        return this.$store.state.notifys
      },
      notify_nums(){
        return this.$store.state.notify_nums
      },
    },
    created(){
      this.db = firebase.firestore()
      //console.log("created",this.pageTitle,this.currentName,this.uid)
    },
    mounted(){
  
    },
    watch:{
    }, 
    methods: {
      //通知
      checkNotify(item,index){
        const type = item.type;
        if(type==0) this.$router.push("/home?page=news")
        if(type==2) this.$router.push("/home?page=offline")
        if(type==3||type=="l1") this.$router.push(`/lid/${item.lidid}/content`)
        if(type==8 || type==9) this.$router.push(`/lid/${item.lidid}/idea`)
        if(type==31||type==32||type==33||type==34) this.$router.push(`/lid/${item.lidid}/idea?id=${item.ideaid}`)
        if(type==10 || type==11 || type==12 || type==13 || type==14 || type==15 || type==16 || type==17 || type==18 || type==19 || type==20 || type==21 || type==22) this.$router.push(`/lid/${item.lidid}/project?id=${item.pjid}`)
        if(type==27 || type==30) this.$emit('openModal', index)
        if(type==90) this.$emit('openModal', index)
      },
      enabledCheckNotify(type) {
        // checkNotifyの条件を満たしているかどうか
        return type==0 || type==2 || type==3 || type=="l1" || type==8 || type==9 || /*type==10 ||*/ type==11 || type==12 || type==13 || type==14 || type==15 || type==16 || type==17 || type==18 || type==19 || type==20 || type==21 || type==22 || type==27 || type==30 || type==31 ||type==32 ||type==33 || type==34 || type==90
      }
    }
  })
  </script>
  
  <style scoped>
  *{
    font-family:mplus-2c-medium;
  }
  
  </style>